import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";

export class FlightModeGameAssets {

    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static MULTIPLIER_FONT = "M_Numbers";

    public static MAIN_GAME_BACKGROUND:string = "resources/images/Intro_BG.jpg";
    public static get MAIN_GAME_BACKGROUND_TEXTURE():PIXI.Texture {
        return  ImgLoader.getImgTexture(FlightModeGameAssets.MAIN_GAME_BACKGROUND);
    }

    static IMAGES_LOGO:string = "resources/images/introLogo.png";
    static get IMAGES_LOGO_TEXTURE():PIXI.Texture {
        return  ImgLoader.getImgTexture(FlightModeGameAssets.IMAGES_LOGO);
    }

    static BASE_GAME_BACKGROUND:string = "BG_Main"
    static FREESPINS_BACKGROUND:string = "BG_FS"
    static REPLAY_CLICK:string = "Click/Click_";

    // spines
    static BIG_WIN_SPINE = "spine/Big_Win.json";
    static MAX_WIN_SPINE = "spine/Max_Win.json";
    static GOD_MODE_POPUP = "spine/Pop_Up_God_Mode.json";
    static EXPLOSIONS_LOW = "spine/SYM_Xplod_LO.json";
    static EXPLOSIONS_MID = "spine/SYM_Xplod_MID.json";
    static EXPLOSIONS_HIGH = "spine/SYM_Xplod_HI.json";
    static EXPLOSIONS_BOMB = "spine/SYM_Xplod_Bomb.json";
    static INTRO_SPINE = "spine/FS_Intro.json";
    static OUTRO_SPINE = "spine/FS_Outro.json";
    static XHOLE_WET = "spine/X_Hole_Wet.json";
    static XHOLE_SPINE = "spine/X_Hole.json";
    static MULTIPLIER_SYMBOL = "spine/MI.json";
    static GOLDEN_MULTIPLIER = "spine/GM.json";
    static MAX_SYMBOL = "spine/MAX.json";
    static BOMB_FUSE = "spine/Bomb.json";
    static LANDING_SPINE = "spine/SYM_Landing.json";
    static SCATTER_SPINE = "spine/Scatter.json";
    static MULTIPLIER_SWEEP = "spine/Next_Multiplier.json";
    static EXTRA_SPIN = "spine/Info_Window.json";

    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro:[],

        main:[
            {
                name:"fonts",
                assets:[
                    new BitmapFontAsset(FlightModeGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(FlightModeGameAssets.MULTIPLIER_FONT, "fonts/bitmapfonts/M_Numbers.fnt"),
                ]
            },
            {
                name:"spine",
                assets:[
                    new SpineAsset(FlightModeGameAssets.BIG_WIN_SPINE, FlightModeGameAssets.BIG_WIN_SPINE),
                    new SpineAsset(FlightModeGameAssets.MAX_WIN_SPINE, FlightModeGameAssets.MAX_WIN_SPINE),
                    new SpineAsset(FlightModeGameAssets.GOD_MODE_POPUP, FlightModeGameAssets.GOD_MODE_POPUP),
                    new SpineAsset(FlightModeGameAssets.EXPLOSIONS_LOW, FlightModeGameAssets.EXPLOSIONS_LOW),
                    new SpineAsset(FlightModeGameAssets.EXPLOSIONS_MID, FlightModeGameAssets.EXPLOSIONS_MID),
                    new SpineAsset(FlightModeGameAssets.EXPLOSIONS_HIGH, FlightModeGameAssets.EXPLOSIONS_HIGH),
                    new SpineAsset(FlightModeGameAssets.EXPLOSIONS_BOMB, FlightModeGameAssets.EXPLOSIONS_BOMB),
                    new SpineAsset(FlightModeGameAssets.INTRO_SPINE, FlightModeGameAssets.INTRO_SPINE),
                    new SpineAsset(FlightModeGameAssets.OUTRO_SPINE, FlightModeGameAssets.OUTRO_SPINE),
                    new SpineAsset(FlightModeGameAssets.XHOLE_WET, FlightModeGameAssets.XHOLE_WET),
                    new SpineAsset(FlightModeGameAssets.XHOLE_SPINE, FlightModeGameAssets.XHOLE_SPINE),
                    new SpineAsset(FlightModeGameAssets.MULTIPLIER_SYMBOL, FlightModeGameAssets.MULTIPLIER_SYMBOL),
                    new SpineAsset(FlightModeGameAssets.MAX_SYMBOL, FlightModeGameAssets.MAX_SYMBOL),
                    new SpineAsset(FlightModeGameAssets.BOMB_FUSE, FlightModeGameAssets.BOMB_FUSE),
                    new SpineAsset(FlightModeGameAssets.LANDING_SPINE, FlightModeGameAssets.LANDING_SPINE),
                    new SpineAsset(FlightModeGameAssets.GOLDEN_MULTIPLIER, FlightModeGameAssets.GOLDEN_MULTIPLIER),
                    new SpineAsset(FlightModeGameAssets.SCATTER_SPINE, FlightModeGameAssets.SCATTER_SPINE),
                    new SpineAsset(FlightModeGameAssets.MULTIPLIER_SWEEP, FlightModeGameAssets.MULTIPLIER_SWEEP),
                    new SpineAsset(FlightModeGameAssets.EXTRA_SPIN, FlightModeGameAssets.EXTRA_SPIN),
                ]
            },
            {
                name:"main",
                autoLoad:[AssetQualityLevel.HIGH],
                assets:[
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                ],
                animations: {}
            },
            {
                name:"backgroundJpeg",
                autoLoad:[AssetQualityLevel.HIGH],
                assets:[
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                ],
            },
            {
                name:"mainJpeg",
                assets:[
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                ],
            },
            //{
            {
                name:"symbols",
                autoLoad:[AssetQualityLevel.HIGH],
                assets:[
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations:{}
            }
        ]
    };

}
